export const checkSpeciality = (idSpecialidad) =>{
    switch(idSpecialidad){
        case 141:
            return true;
        case 142:
            return true;
        default:
            return false;
    }
}